<template>
  <div class="add-section">
    <!-- 支払情報テーブル（状態に応じて切り替え） -->
    <!-- メインコンテナと日付が同じか、前のセクションと日付が同じ場合は非表示 -->
    <div v-if="!isSameDateAsMain && isFirstInDateGroup">
      <NormalPaymentInfo 
        v-if="sectionData.displayType === 'normal'"
        :paymentDate="sectionData.paymentDate"
        :amount="sectionData.paymentInfo"
        class="mb-3"
      />
      
      <ErrorPaymentInfo
        v-if="sectionData.displayType === 'error' && sectionData.paymentInfo != 0"
        :error-reason="sectionData.errorReason"
        :expiration-date="sectionData.expirationDate"
        :amount="sectionData.paymentInfo"
        :expirationManual-date="sectionData.expirationDateManual"
        class="mb-3"
      />

      <ExpiredPaymentInfo
        v-if="sectionData.displayType === 'expired' && sectionData.paymentInfo != 0"
        :expirationDate="sectionData.expirationDate"
        :amount="sectionData.paymentInfo"
        class="mb-3"
      />
    </div>
    
    <!-- 明細テーブル -->
    <div class="section-header" @click="isOpen = !isOpen">
      <div class="section-title">
        <span class="collapse-icon">
          <i class="fa fa-minus-circle"></i>
        </span>
        <img v-if="!isOpen" src="@/assets/img/ac_1.gif" alt="Open" class="mr-4" style="width: 15px; height: 15px;" />
        <img v-else src="@/assets/img/ac_2.gif" alt="Open" class="mr-4" style="width: 15px; height: 15px;" />
        {{ sectionData.commissionLabel }}
      </div>
      <div class="amount">{{ sectionData.totalAmount }}円</div>
    </div>
    
    <div class="section-content" v-show="isOpen">
      <table class="commission-table">
        <tbody>
          <!-- 税額計算 -->
          <tr>
            <td>①コミッション合計金額(税込)</td>
            <td class="text-right">{{ sectionData.totalWithTax }}円</td>
          </tr>
          <tr>
            <td>コミッション合計金額(10%税抜)</td>
            <td class="text-right">{{ sectionData.totalWithoutTax }}円</td>
          </tr>
          <tr>
            <td>コミッション合計金額(消費税)</td>
            <td class="text-right">{{ sectionData.consumptionTax }}円</td>
          </tr>
          <tr>
            <td>②経過措置額(10%税抜)</td>
            <td class="text-right">{{ sectionData.transitionalAmount }}円</td>
          </tr>
          <tr>
            <td>③経過措置額(消費税)</td>
            <td class="text-right">{{ sectionData.transitionalTax }}円</td>
          </tr>
          <!-- 源泉徴収 -->
          <tr>
            <td>④源泉徴収税額</td>
            <td class="text-right">{{ sectionData.withholdingTax }}円</td>
          </tr>
          <!-- 支払額計算 -->
          <tr>
            <td v-if="!hasRegistrationNumber">合計(①-②-③-④) ※80%控除対象</td>
            <td v-else>合計(①-②-③-④)</td>
            <td class="text-right">{{ sectionData.totalAfterDeductions }}円</td>
          </tr>
          <tr>
            <td>通知書発行手数料</td>
            <td class="text-right">{{ sectionData.notificationFee }}円</td>
          </tr>
          <tr class="total-row">
            <td>お支払金額</td>
            <td class="text-right amount">{{ sectionData.totalAmount }}円</td>
          </tr>
        </tbody>
      </table>

      <!-- 標準の注意書き -->
      <StandardNotes :fiscalYear=fiscalYear />
    </div>
  </div>
</template>

<script>
import NormalPaymentInfo from '@/views/details/components/NormalPaymentInfo.vue';
import ErrorPaymentInfo from '@/views/details/components/ErrorPaymentInfo.vue';
import ExpiredPaymentInfo from '@/views/details/components/ExpiredPaymentInfo.vue';
import StandardNotes from "@/views/details/components/StandardNotes.vue";

export default {
  name: 'AddSection1',
  components: {
    NormalPaymentInfo,
    ErrorPaymentInfo,
    ExpiredPaymentInfo,
    StandardNotes
  },
  props: {
    sectionData: {
      type: Object,
      default: () => ({})
    },
    paymentDisplayType: {
      type: String,
      default: 'normal',
      validator: (value) => ['normal', 'error', 'expired'].includes(value)
    },
    isSameDateAsMain: {
      type: Boolean,
      default: false
    },
    isSameAsPrevSection: {
      type: Boolean,
      default: false
    },
    isFirstInDateGroup: {
      type: Boolean,
      default: true
    },
    mainContainerDate: {
      type: String,
      default: ''
    },
    hasRegistrationNumber: {
      type: Boolean,
      default: false
    },
    fiscalYear: {
      type: String,
      default: '0'
    },
    expirationManualDate: {
      type: String,
      default: "",
    },
    expirationData: {
      type: String,
      default: "",
    },
    islast: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  watch: {
      sectionData() {
        this.isOpen = false;
      },
  }
};
</script>

<style scoped>
.add-section {
  margin-bottom: 20px;
}

.payment-info-table {
  margin-bottom: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #f5f5f5;
  cursor: pointer;
  border-radius: 4px 4px 0 0;
  border: 1px solid #ddd;
}

.section-title {
  font-weight: 600;
  display: flex;
  align-items: center;
}

.collapse-icon {
  margin-right: 10px;
  color: #666;
}

.amount {
  font-weight: bold;
}

.section-content {
  padding: 15px;
  border: 1px solid #ddd;
  border-top: none;
  border-radius: 0 0 4px 4px;
}

.commission-table {
  width: 100%;
  border-collapse: collapse;
}

.commission-table th, .commission-table td {
  padding: 8px 15px;
  border-bottom: 1px solid #ddd;
}

.commission-table th {
  background-color: #f0f0f0;
  text-align: center;
}

.commission-table tr td:first-child {
  min-width: 320px;
}

.table-header {
  background-color: #f5f5f5;
  font-weight: 600;
  text-align: left;
}

.text-right {
  text-align: right;
}

.total-row {
  background-color: #f0f0f0;
  font-weight: 600;
}

.total-row .amount {
  color: #e74c3c;
}

.mb-3 {
  margin-bottom: 15px;
}

/* スマートフォンレイアウト */
@media screen and (min-width: 1px) and (max-width: 991px) {
  .section-content {
    padding: 0px;
  }
  .commission-table tr td:first-child {
    min-width: inherit;
  }
}
</style> 